module.exports = __webpack_public_path__ + "static/media/arrow-alt-down.814a015d.svg";